import { render, staticRenderFns } from "./AgentInput.vue?vue&type=template&id=06a89a46"
import script from "./AgentInput.vue?vue&type=script&lang=js"
export * from "./AgentInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports